export const QES_SUPERSEDED_LOOPBLOCK = Symbol('queue:superseded-loopblock');
